exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal.component {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  z-index: 300;\n}\n\n.modal.component .overlay {\n  position: absolute;\n  background: rgba(0,0,0,0.7);\n  width: 100%;\n  height: 100%;\n}\n\n.modal.component .modal-frame {\n  z-index: 300;\n}\n\n.modal.component .modal-body h4 {\n    padding-top: 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/modal/modal.css
// module id = 762
// module chunks = 0